import { render, staticRenderFns } from "./VButtonPessoalData.vue?vue&type=template&id=5bd86272&scoped=true"
import script from "./VButtonPessoalData.vue?vue&type=script&lang=js"
export * from "./VButtonPessoalData.vue?vue&type=script&lang=js"
import style0 from "./VButtonPessoalData.vue?vue&type=style&index=0&id=5bd86272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd86272",
  null
  
)

export default component.exports